class VirtualTryOn extends HHBaseElement {
  constructor() {
    super()
    this.isReady = false
    this._isOpen = false
    this.mainProduct = this.closest('product-main')
    this._handleMakeupApplied = this._handleMakeupApplied.bind(this)
    this._handleClick = this._handleClick.bind(this)
    this._handleEngineClosed = this._handleEngineClosed.bind(this)
    this._applyMakeupFilter = this._applyMakeupFilter.bind(this)
    this._handleOpened = this._handleOpened.bind(this)
    this._handleClosed = this._handleClosed.bind(this)
    this._handleSelectedVariantChange = this._handleSelectedVariantChange.bind(this)
    this.target = document.getElementById('YMK-module')

    if (document.querySelectorAll('virtual-try-on').length > 1) {
      throw new Error('Only one virtual-try-on component can be used per page')
    }
    this.$button = this.querySelector('button')
    this.sectionId = this.mainProduct.getAttribute('section-id') 
    this.$MediaGallery = this.mainProduct.querySelector(`[id*="MediaGallery-${this.sectionId}"] .gallery-main`)

    this.mql = window.matchMedia('(min-width: 992px)')

    // this._injectTarget()
    if (!this.isQuickShop) {
      this._initScript()
    }
  }

  get isOpen() {
    return this._isOpen
  }

  set isOpen(value) {
    this._isOpen = value
    this.target.classList.toggle('open', value)
  }

  get apiKey() {
    return this.getAttribute('api-key')
  }

  get widgetId() {
    return this.getAttribute('widget-id')
  }

  get language() {
    return this.getAttribute('language')
  }

  get enableKissDetection() {
    return this.hasAttribute('enable-kiss-detect')
  }

  get privacyPolicyURL() {
    return this.getAttribute('privacy-policy')
  }

  get isQuickShop() {
    return this.getAttribute('quick-shop') === 'true'
  }

  get productUrl() {
    return this.getAttribute('data-url')
  }

  get productData() {
    return this.mainProduct.product
  }

  get selectedVariantSKU() {
    return this.getAttribute('variant-id')
  }

  _handleMakeupApplied(success) {}

  _injectTarget() {
    this.target = document.createElement('div')
    this.target.id = 'YMK-module'
    this.target.setAttribute(
      'class',
      'ymk-module background-color-off-white grid justify-center'
    )
    this.target.setAttribute('role', 'region')
    this.target.setAttribute('aria-label', 'Camera virtual try-on')
  }

  _initScript() {
    if (document.getElementById('ymk-script')) {
      this._initWidget()
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.id = 'ymk-script'
      window.ymkAsyncInit = () => {
        this._initWidget()
      }
      script.src = `https://plugins-media.makeupar.com/${this.widgetId}/sdk.js?apiKey=${this.apiKey}`
      document.body.appendChild(script)
    }
  }

  static get observedAttributes() {
    return ['variant-id']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'variant-id' && this.isReady && oldValue !== newValue) {
      this._handleSelectedVariantChange()
    }
  }

  _initWidget(open) {
    this.isReady = true
    YMK.addEventListener('loaded', this._applyMakeupFilter)
    YMK.addEventListener('loaded', this._handleOpened)
    YMK.addEventListener('opened', this._handleOpened)
    YMK.addEventListener('engineClosed', this._handleEngineClosed)
    YMK.addEventListener('closed', this._handleClosed)
    YMK.init({
      autoOpen: false,
      language: this.language,
      enableKissDetection: this.enableKissDetection,
      privacyPolicyURL: this.privacyPolicyURL,
      height: Math.min(this.target.clientHeight, 600),
      width: Math.min(this.target.clientWidth, 600),
    })
    if (location.hash === '#virtual-try-on' || open === true) {
      this.show()
    }
  }

  _handleOpened() {
    this.isOpen = true
    this.target.scrollIntoView({ behavior: 'smooth' })
    this.target.style.zIndex = '10'
  }

  _handleEngineClosed() {
    this.isOpen = false
    this.target.style.zIndex = 0
    YMK.close()
  }

  _handleClosed() {
    this.target.classList.remove('open')
    this.isOpen = false
  }

  _applyMakeupFilter() {
    if (!this.isReady) return
    YMK.applyMakeupBySku(this.selectedVariantSKU, this._handleMakeupApplied)
  }

  _handleClick() {
    if (this.isQuickShop) {
      location.href = this.productUrl
    } else {
      if (!!this.selectedVariantSKU) {
        this.show()
      } else {
        throw new Error('Failed to Find SKU')
      }
    }
  }

  _handleSelectedVariantChange() {
    if (!!this.selectedVariantSKU) {
      this._applyMakeupFilter()
      this.$button?.removeAttribute('disabled')
    } else {
      if (this.$button) this.$button.disabled = 'true'

      if (this.isOpen) {
        this.close()
      }
    }
  }

  _resetWidget(wasOpen) {
    YMK.removeEventListener('loaded', this._applyMakeupFilter)
    YMK.removeEventListener('loaded', this._handleOpened)
    YMK.removeEventListener('opened', this._handleOpened)
    YMK.removeEventListener('engineClosed', this._handleEngineClosed)
    YMK.removeEventListener('closed', this._handleClosed)
    this.isOpen = false
    this._initWidget(wasOpen)
  }

  _handleMediaQuery() {
    if (this.target.parentNode) {
      if (this.target.classList.contains('open')) {
        this.close()
      }
      this.target.parentNode.removeChild(this.target)
    }
    this.target.innerHTML = ''
    this.$MediaGallery.appendChild(this.target)
  }

  _attachListeners() {
    this._handleMediaQuery()
    this.mql.onchange = (e) => {
      const wasOpen = this.isOpen
      this._handleMediaQuery()
      if (this.isReady) {
        this._resetWidget(wasOpen)
      }
    }
    this.addEventListener('click', this._handleClick)
  }

  _removeListeners() {
    this.mql.onchange = null
    this.removeEventListener('click', this._handleClick)
    this._resetWidget()
  }

  close() {
    this.target.classList.remove('open')
    YMK.closeEngine()
  }

  show() {
    this.target.classList.add('open')

    if (this.isOpen) {
      this._applyMakeupFilter()
    } else {
      YMK.open(true)
    }
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  connectedCallback() {
    this._attachListeners()
  }
}

window.customElements.define('virtual-try-on', VirtualTryOn)
